/**
 * Decline-with-reason options. Values MUST match the muncher enum in
 * crossbeam.routes.schemas.proposals/decline-reasons. Labels are user-facing.
 */
export interface DeclineReasonOption {
  value: DeclineReasonType;
  label: string;
}

export type DeclineReasonType =
  | 'bad_timing'
  | 'legal_data_policy'
  | 'no_formal_partnership'
  | 'other'
  | 'prefer_not_to_say'
  | 'wrong_person';

export const DECLINE_REASON_PREFER_NOT_TO_SAY: DeclineReasonType =
  'prefer_not_to_say';

export const DECLINE_REASONS: DeclineReasonOption[] = [
  { value: 'legal_data_policy', label: 'Legal or data privacy restrictions' },
  { value: 'bad_timing', label: 'Bad timing — reconnect later' },
  {
    value: 'no_formal_partnership',
    label: 'No formal partnership in place yet',
  },
  { value: 'wrong_person', label: 'Not the right person' },
  { value: 'other', label: 'Other' },
  { value: DECLINE_REASON_PREFER_NOT_TO_SAY, label: 'Prefer not to say' },
];

export const DECLINE_REASON_LABELS: Record<string, string> = Object.fromEntries(
  DECLINE_REASONS.map((r) => [r.value, r.label]),
);

export const MAX_DECLINE_NOTE_LENGTH = 1000;
